// extracted by mini-css-extract-plugin
module.exports = {"search":"_9400a595a7--search--dYo55","content":"_9400a595a7--content--z2NBD"};